@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.marketplace.resources/"

@delegate:ResourceContentHash(319_791_594)
internal val Res.string.marketplace_add_photo: StringResource by lazy {
      StringResource("string:marketplace_add_photo", "marketplace_add_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 143, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107, 41),
      ))
    }

@delegate:ResourceContentHash(-999_733_427)
internal val Res.string.marketplace_add_photo_failed: StringResource by lazy {
      StringResource("string:marketplace_add_photo_failed", "marketplace_add_photo_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 96),
      ))
    }

@delegate:ResourceContentHash(2_099_218_371)
internal val Res.string.marketplace_all: StringResource by lazy {
      StringResource("string:marketplace_all", "marketplace_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 266, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 230, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 198, 35),
      ))
    }

@delegate:ResourceContentHash(481_519_240)
internal val Res.string.marketplace_all_listings: StringResource by lazy {
      StringResource("string:marketplace_all_listings", "marketplace_all_listings", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 201, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 169, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 149, 48),
      ))
    }

@delegate:ResourceContentHash(-574_583_101)
internal val Res.string.marketplace_back_a11y: StringResource by lazy {
      StringResource("string:marketplace_back_a11y", "marketplace_back_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 322, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 278, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234, 41),
      ))
    }

@delegate:ResourceContentHash(-1_256_663_562)
internal val Res.string.marketplace_cat_all: StringResource by lazy {
      StringResource("string:marketplace_cat_all", "marketplace_cat_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 368, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 316, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 276, 31),
      ))
    }

@delegate:ResourceContentHash(1_641_951_060)
internal val Res.string.marketplace_cat_appliances: StringResource by lazy {
      StringResource("string:marketplace_cat_appliances", "marketplace_cat_appliances", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 404, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 352, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 308, 50),
      ))
    }

@delegate:ResourceContentHash(-1_526_375_944)
internal val Res.string.marketplace_cat_books: StringResource by lazy {
      StringResource("string:marketplace_cat_books", "marketplace_cat_books", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 467, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 411, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 359, 49),
      ))
    }

@delegate:ResourceContentHash(-43_207_882)
internal val Res.string.marketplace_cat_clothing: StringResource by lazy {
      StringResource("string:marketplace_cat_clothing", "marketplace_cat_clothing", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 529, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 465, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 409, 44),
      ))
    }

@delegate:ResourceContentHash(-2_027_519_050)
internal val Res.string.marketplace_cat_electronics: StringResource by lazy {
      StringResource("string:marketplace_cat_electronics", "marketplace_cat_electronics", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 578, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 514, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 454, 51),
      ))
    }

@delegate:ResourceContentHash(-1_351_571_054)
internal val Res.string.marketplace_cat_furniture: StringResource by lazy {
      StringResource("string:marketplace_cat_furniture", "marketplace_cat_furniture", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 638, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 570, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 506, 45),
      ))
    }

@delegate:ResourceContentHash(1_223_571_619)
internal val Res.string.marketplace_cat_home_kitchen: StringResource by lazy {
      StringResource("string:marketplace_cat_home_kitchen", "marketplace_cat_home_kitchen", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 688, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 616, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 552, 56),
      ))
    }

@delegate:ResourceContentHash(1_990_083_676)
internal val Res.string.marketplace_cat_kids: StringResource by lazy {
      StringResource("string:marketplace_cat_kids", "marketplace_cat_kids", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 765, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 677, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 609, 44),
      ))
    }

@delegate:ResourceContentHash(-1_521_513_839)
internal val Res.string.marketplace_cat_other: StringResource by lazy {
      StringResource("string:marketplace_cat_other", "marketplace_cat_other", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 826, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 730, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 654, 37),
      ))
    }

@delegate:ResourceContentHash(326_405_943)
internal val Res.string.marketplace_cat_sports: StringResource by lazy {
      StringResource("string:marketplace_cat_sports", "marketplace_cat_sports", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 868, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 768, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 692, 54),
      ))
    }

@delegate:ResourceContentHash(-628_588_018)
internal val Res.string.marketplace_cat_vehicles: StringResource by lazy {
      StringResource("string:marketplace_cat_vehicles", "marketplace_cat_vehicles", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 931, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 827, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 747, 44),
      ))
    }

@delegate:ResourceContentHash(1_070_261_581)
internal val Res.string.marketplace_condition: StringResource by lazy {
      StringResource("string:marketplace_condition", "marketplace_condition", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1136, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1016, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 924, 41),
      ))
    }

@delegate:ResourceContentHash(-207_129_702)
internal val Res.string.marketplace_condition_like_new: StringResource by lazy {
      StringResource("string:marketplace_condition_like_new", "marketplace_condition_like_new", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 980, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 876, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 792, 50),
      ))
    }

@delegate:ResourceContentHash(1_438_244_012)
internal val Res.string.marketplace_condition_new: StringResource by lazy {
      StringResource("string:marketplace_condition_new", "marketplace_condition_new", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1039, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 931, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 843, 37),
      ))
    }

@delegate:ResourceContentHash(-429_538_633)
internal val Res.string.marketplace_condition_used: StringResource by lazy {
      StringResource("string:marketplace_condition_used", "marketplace_condition_used", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1081, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 973, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 881, 42),
      ))
    }

@delegate:ResourceContentHash(-578_882_492)
internal val Res.string.marketplace_deal_claim: StringResource by lazy {
      StringResource("string:marketplace_deal_claim", "marketplace_deal_claim", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1182, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1054, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 966, 46),
      ))
    }

@delegate:ResourceContentHash(-1_290_417_592)
internal val Res.string.marketplace_deal_ends_days: StringResource by lazy {
      StringResource("string:marketplace_deal_ends_days", "marketplace_deal_ends_days", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1261, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1113, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1013, 58),
      ))
    }

@delegate:ResourceContentHash(1_312_398_796)
internal val Res.string.marketplace_deal_ends_today: StringResource by lazy {
      StringResource("string:marketplace_deal_ends_today", "marketplace_deal_ends_today", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1356, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1184, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1072, 51),
      ))
    }

@delegate:ResourceContentHash(1_401_144_942)
internal val Res.string.marketplace_deal_image_a11y: StringResource by lazy {
      StringResource("string:marketplace_deal_image_a11y", "marketplace_deal_image_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1436, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1252, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1124, 55),
      ))
    }

@delegate:ResourceContentHash(1_007_895_747)
internal val Res.string.marketplace_deal_limited: StringResource by lazy {
      StringResource("string:marketplace_deal_limited", "marketplace_deal_limited", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1500, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1308, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1180, 48),
      ))
    }

@delegate:ResourceContentHash(1_976_773_489)
internal val Res.string.marketplace_deal_open_a11y: StringResource by lazy {
      StringResource("string:marketplace_deal_open_a11y", "marketplace_deal_open_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1557, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1361, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1229, 50),
      ))
    }

@delegate:ResourceContentHash(485_390_345)
internal val Res.string.marketplace_delete_action: StringResource by lazy {
      StringResource("string:marketplace_delete_action", "marketplace_delete_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1632, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1420, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1280, 53),
      ))
    }

@delegate:ResourceContentHash(-946_185_051)
internal val Res.string.marketplace_delete_confirm: StringResource by lazy {
      StringResource("string:marketplace_delete_confirm", "marketplace_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1686, 166),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1482, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1334, 110),
      ))
    }

@delegate:ResourceContentHash(-1_425_781_203)
internal val Res.string.marketplace_delete_failed: StringResource by lazy {
      StringResource("string:marketplace_delete_failed", "marketplace_delete_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1853, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1613, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1445, 85),
      ))
    }

@delegate:ResourceContentHash(358_382_606)
internal val Res.string.marketplace_description: StringResource by lazy {
      StringResource("string:marketplace_description", "marketplace_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1975, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1695, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1531, 47),
      ))
    }

@delegate:ResourceContentHash(1_096_550_148)
internal val Res.string.marketplace_edit: StringResource by lazy {
      StringResource("string:marketplace_edit", "marketplace_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2277, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1941, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1757, 40),
      ))
    }

@delegate:ResourceContentHash(-1_314_864_961)
internal val Res.string.marketplace_edit_action: StringResource by lazy {
      StringResource("string:marketplace_edit_action", "marketplace_edit_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2027, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1743, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1579, 39),
      ))
    }

@delegate:ResourceContentHash(-773_020_695)
internal val Res.string.marketplace_edit_failed: StringResource by lazy {
      StringResource("string:marketplace_edit_failed", "marketplace_edit_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2075, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1787, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1619, 91),
      ))
    }

@delegate:ResourceContentHash(1_020_354_813)
internal val Res.string.marketplace_edit_save: StringResource by lazy {
      StringResource("string:marketplace_edit_save", "marketplace_edit_save", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2211, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1895, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1711, 45),
      ))
    }

@delegate:ResourceContentHash(-1_651_886_275)
internal val Res.string.marketplace_empty_description: StringResource by lazy {
      StringResource("string:marketplace_empty_description", "marketplace_empty_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2330, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1994, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1798, 109),
      ))
    }

@delegate:ResourceContentHash(-623_000_471)
internal val Res.string.marketplace_empty_title: StringResource by lazy {
      StringResource("string:marketplace_empty_title", "marketplace_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2500, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2096, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1908, 47),
      ))
    }

@delegate:ResourceContentHash(-1_670_701_381)
internal val Res.string.marketplace_error: StringResource by lazy {
      StringResource("string:marketplace_error", "marketplace_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2576, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2148, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1956, 77),
      ))
    }

@delegate:ResourceContentHash(-1_435_106_176)
internal val Res.string.marketplace_featured_section: StringResource by lazy {
      StringResource("string:marketplace_featured_section", "marketplace_featured_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2690, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2238, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2034, 48),
      ))
    }

@delegate:ResourceContentHash(129_066_643)
internal val Res.string.marketplace_free: StringResource by lazy {
      StringResource("string:marketplace_free", "marketplace_free", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2739, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2291, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2083, 32),
      ))
    }

@delegate:ResourceContentHash(-105_823_530)
internal val Res.string.marketplace_hot_deals: StringResource by lazy {
      StringResource("string:marketplace_hot_deals", "marketplace_hot_deals", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2780, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2328, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2116, 41),
      ))
    }

@delegate:ResourceContentHash(-1_764_335_003)
internal val Res.string.marketplace_image_a11y: StringResource by lazy {
      StringResource("string:marketplace_image_a11y", "marketplace_image_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2846, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2382, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2158, 50),
      ))
    }

@delegate:ResourceContentHash(1_040_097_348)
internal val Res.string.marketplace_item_description: StringResource by lazy {
      StringResource("string:marketplace_item_description", "marketplace_item_description", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2897, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2433, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2209, 60),
      ))
    }

@delegate:ResourceContentHash(1_100_875_475)
internal val Res.string.marketplace_location: StringResource by lazy {
      StringResource("string:marketplace_location", "marketplace_location", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2966, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2506, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2270, 48),
      ))
    }

@delegate:ResourceContentHash(867_805_187)
internal val Res.string.marketplace_mark_sold: StringResource by lazy {
      StringResource("string:marketplace_mark_sold", "marketplace_mark_sold", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3579, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2943, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2663, 45),
      ))
    }

@delegate:ResourceContentHash(1_678_048_661)
internal val Res.string.marketplace_mark_sold_cancel: StringResource by lazy {
      StringResource("string:marketplace_mark_sold_cancel", "marketplace_mark_sold_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3015, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2551, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2319, 56),
      ))
    }

@delegate:ResourceContentHash(1_141_504_057)
internal val Res.string.marketplace_mark_sold_confirm: StringResource by lazy {
      StringResource("string:marketplace_mark_sold_confirm", "marketplace_mark_sold_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3080, 353),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2612, 217),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2376, 189),
      ))
    }

@delegate:ResourceContentHash(-1_577_663_255)
internal val Res.string.marketplace_mark_sold_failed: StringResource by lazy {
      StringResource("string:marketplace_mark_sold_failed", "marketplace_mark_sold_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3434, 144),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2830, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2566, 96),
      ))
    }

@delegate:ResourceContentHash(1_677_318_645)
internal val Res.string.marketplace_message_seller: StringResource by lazy {
      StringResource("string:marketplace_message_seller", "marketplace_message_seller", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3815, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3111, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2803, 54),
      ))
    }

@delegate:ResourceContentHash(-1_335_673_899)
internal val Res.string.marketplace_message_seller_failed: StringResource by lazy {
      StringResource("string:marketplace_message_seller_failed", "marketplace_message_seller_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3693, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3001, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2709, 93),
      ))
    }

@delegate:ResourceContentHash(2_003_189_633)
internal val Res.string.marketplace_more_from_seller: StringResource by lazy {
      StringResource("string:marketplace_more_from_seller", "marketplace_more_from_seller", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3890, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3174, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2858, 64),
      ))
    }

@delegate:ResourceContentHash(-994_381_586)
internal val Res.string.marketplace_my_listings: StringResource by lazy {
      StringResource("string:marketplace_my_listings", "marketplace_my_listings", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3991, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3235, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2923, 51),
      ))
    }

@delegate:ResourceContentHash(2_102_506_860)
internal val Res.string.marketplace_photo_upload_warning: StringResource by lazy {
      StringResource("string:marketplace_photo_upload_warning", "marketplace_photo_upload_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4116, 276),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3340, 216),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3036, 168),
      ))
    }

@delegate:ResourceContentHash(1_243_119_237)
internal val Res.string.marketplace_photo_upload_warning_dismiss: StringResource by lazy {
      StringResource("string:marketplace_photo_upload_warning_dismiss", "marketplace_photo_upload_warning_dismiss", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4055, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3283, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2975, 60),
      ))
    }

@delegate:ResourceContentHash(-1_666_034_974)
internal val Res.string.marketplace_price: StringResource by lazy {
      StringResource("string:marketplace_price", "marketplace_price", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4724, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3828, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3452, 41),
      ))
    }

@delegate:ResourceContentHash(-1_807_538_388)
internal val Res.string.marketplace_price_50_200: StringResource by lazy {
      StringResource("string:marketplace_price_50_200", "marketplace_price_50_200", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4393, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3557, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3205, 48),
      ))
    }

@delegate:ResourceContentHash(-1_486_575_846)
internal val Res.string.marketplace_price_any: StringResource by lazy {
      StringResource("string:marketplace_price_any", "marketplace_price_any", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4462, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3606, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3254, 41),
      ))
    }

@delegate:ResourceContentHash(2_145_505_617)
internal val Res.string.marketplace_price_over_200: StringResource by lazy {
      StringResource("string:marketplace_price_over_200", "marketplace_price_over_200", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4524, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3656, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3296, 46),
      ))
    }

@delegate:ResourceContentHash(1_420_968_708)
internal val Res.string.marketplace_price_unavailable: StringResource by lazy {
      StringResource("string:marketplace_price_unavailable", "marketplace_price_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4595, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3711, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3343, 61),
      ))
    }

@delegate:ResourceContentHash(-674_411_363)
internal val Res.string.marketplace_price_under_50: StringResource by lazy {
      StringResource("string:marketplace_price_under_50", "marketplace_price_under_50", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4661, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3773, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3405, 46),
      ))
    }

@delegate:ResourceContentHash(-247_609_468)
internal val Res.string.marketplace_report_action: StringResource by lazy {
      StringResource("string:marketplace_report_action", "marketplace_report_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4766, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3870, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3494, 53),
      ))
    }

@delegate:ResourceContentHash(-481_935_050)
internal val Res.string.marketplace_report_done: StringResource by lazy {
      StringResource("string:marketplace_report_done", "marketplace_report_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4828, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3932, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3548, 39),
      ))
    }

@delegate:ResourceContentHash(-1_500_097_184)
internal val Res.string.marketplace_report_failed: StringResource by lazy {
      StringResource("string:marketplace_report_failed", "marketplace_report_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4872, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3976, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3588, 89),
      ))
    }

@delegate:ResourceContentHash(-283_302_589)
internal val Res.string.marketplace_report_reason_offensive: StringResource by lazy {
      StringResource("string:marketplace_report_reason_offensive", "marketplace_report_reason_offensive", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5002, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4082, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3678, 67),
      ))
    }

@delegate:ResourceContentHash(-1_599_891_386)
internal val Res.string.marketplace_report_reason_prohibited: StringResource by lazy {
      StringResource("string:marketplace_report_reason_prohibited", "marketplace_report_reason_prohibited", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5094, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4150, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3746, 80),
      ))
    }

@delegate:ResourceContentHash(-318_576_167)
internal val Res.string.marketplace_report_reason_scam: StringResource by lazy {
      StringResource("string:marketplace_report_reason_scam", "marketplace_report_reason_scam", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5199, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4235, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3827, 58),
      ))
    }

@delegate:ResourceContentHash(-295_939_024)
internal val Res.string.marketplace_report_reason_spam: StringResource by lazy {
      StringResource("string:marketplace_report_reason_spam", "marketplace_report_reason_spam", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5286, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4298, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3886, 62),
      ))
    }

@delegate:ResourceContentHash(-1_636_580_162)
internal val Res.string.marketplace_report_sent: StringResource by lazy {
      StringResource("string:marketplace_report_sent", "marketplace_report_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5385, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4365, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3949, 91),
      ))
    }

@delegate:ResourceContentHash(-1_054_499_435)
internal val Res.string.marketplace_report_submit: StringResource by lazy {
      StringResource("string:marketplace_report_submit", "marketplace_report_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5529, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4461, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4041, 53),
      ))
    }

@delegate:ResourceContentHash(1_901_254_608)
internal val Res.string.marketplace_report_title: StringResource by lazy {
      StringResource("string:marketplace_report_title", "marketplace_report_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5591, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4527, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4095, 60),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.marketplace_retry: StringResource by lazy {
      StringResource("string:marketplace_retry", "marketplace_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5660, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4592, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4156, 37),
      ))
    }

@delegate:ResourceContentHash(833_280_360)
internal val Res.string.marketplace_save_a11y: StringResource by lazy {
      StringResource("string:marketplace_save_a11y", "marketplace_save_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5714, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4634, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4194, 41),
      ))
    }

@delegate:ResourceContentHash(1_793_734_692)
internal val Res.string.marketplace_saved: StringResource by lazy {
      StringResource("string:marketplace_saved", "marketplace_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5823, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4743, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4275, 33),
      ))
    }

@delegate:ResourceContentHash(1_054_194_458)
internal val Res.string.marketplace_saved_a11y: StringResource by lazy {
      StringResource("string:marketplace_saved_a11y", "marketplace_saved_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5772, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4696, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4236, 38),
      ))
    }

@delegate:ResourceContentHash(372_304_404)
internal val Res.string.marketplace_search_placeholder: StringResource by lazy {
      StringResource("string:marketplace_search_placeholder", "marketplace_search_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5885, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4785, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4309, 74),
      ))
    }

@delegate:ResourceContentHash(893_463_207)
internal val Res.string.marketplace_sell: StringResource by lazy {
      StringResource("string:marketplace_sell", "marketplace_sell", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7691, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6343, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5751, 40),
      ))
    }

@delegate:ResourceContentHash(-788_203_313)
internal val Res.string.marketplace_sell_category_label: StringResource by lazy {
      StringResource("string:marketplace_sell_category_label", "marketplace_sell_category_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5968, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4864, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4384, 51),
      ))
    }

@delegate:ResourceContentHash(828_458_534)
internal val Res.string.marketplace_sell_city_label: StringResource by lazy {
      StringResource("string:marketplace_sell_city_label", "marketplace_sell_city_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6020, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4920, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4436, 43),
      ))
    }

@delegate:ResourceContentHash(-356_092_146)
internal val Res.string.marketplace_sell_city_placeholder: StringResource by lazy {
      StringResource("string:marketplace_sell_city_placeholder", "marketplace_sell_city_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6064, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4964, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4480, 61),
      ))
    }

@delegate:ResourceContentHash(1_070_261_581)
internal val Res.string.marketplace_sell_condition_label: StringResource by lazy {
      StringResource("string:marketplace_sell_condition_label", "marketplace_sell_condition_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6146, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5030, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4542, 52),
      ))
    }

@delegate:ResourceContentHash(1_345_273_278)
internal val Res.string.marketplace_sell_cta: StringResource by lazy {
      StringResource("string:marketplace_sell_cta", "marketplace_sell_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6203, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5079, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4595, 36),
      ))
    }

@delegate:ResourceContentHash(358_382_606)
internal val Res.string.marketplace_sell_desc_label: StringResource by lazy {
      StringResource("string:marketplace_sell_desc_label", "marketplace_sell_desc_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6244, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5116, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4632, 51),
      ))
    }

@delegate:ResourceContentHash(-190_880_512)
internal val Res.string.marketplace_sell_desc_placeholder: StringResource by lazy {
      StringResource("string:marketplace_sell_desc_placeholder", "marketplace_sell_desc_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6300, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5168, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4684, 81),
      ))
    }

@delegate:ResourceContentHash(-466_144_190)
internal val Res.string.marketplace_sell_error: StringResource by lazy {
      StringResource("string:marketplace_sell_error", "marketplace_sell_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6446, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5266, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4766, 94),
      ))
    }

@delegate:ResourceContentHash(-2_119_874_900)
internal val Res.string.marketplace_sell_free: StringResource by lazy {
      StringResource("string:marketplace_sell_free", "marketplace_sell_free", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6573, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5361, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4861, 57),
      ))
    }

@delegate:ResourceContentHash(-2_137_467_650)
internal val Res.string.marketplace_sell_invite_cta: StringResource by lazy {
      StringResource("string:marketplace_sell_invite_cta", "marketplace_sell_invite_cta", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6643, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5419, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4919, 51),
      ))
    }

@delegate:ResourceContentHash(774_673_251)
internal val Res.string.marketplace_sell_invite_desc: StringResource by lazy {
      StringResource("string:marketplace_sell_invite_desc", "marketplace_sell_invite_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6699, 228),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5483, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4971, 156),
      ))
    }

@delegate:ResourceContentHash(-808_606_506)
internal val Res.string.marketplace_sell_invite_title: StringResource by lazy {
      StringResource("string:marketplace_sell_invite_title", "marketplace_sell_invite_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6928, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5660, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5128, 65),
      ))
    }

@delegate:ResourceContentHash(234_182_080)
internal val Res.string.marketplace_sell_photo_main: StringResource by lazy {
      StringResource("string:marketplace_sell_photo_main", "marketplace_sell_photo_main", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7010, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5730, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5194, 43),
      ))
    }

@delegate:ResourceContentHash(1_840_294_903)
internal val Res.string.marketplace_sell_photo_remove: StringResource by lazy {
      StringResource("string:marketplace_sell_photo_remove", "marketplace_sell_photo_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7058, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5782, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5238, 53),
      ))
    }

@delegate:ResourceContentHash(696_637_353)
internal val Res.string.marketplace_sell_photos_label: StringResource by lazy {
      StringResource("string:marketplace_sell_photos_label", "marketplace_sell_photos_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7116, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5844, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5292, 73),
      ))
    }

@delegate:ResourceContentHash(-1_300_603_701)
internal val Res.string.marketplace_sell_price_label: StringResource by lazy {
      StringResource("string:marketplace_sell_price_label", "marketplace_sell_price_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7206, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5934, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5366, 52),
      ))
    }

@delegate:ResourceContentHash(-851_813_018)
internal val Res.string.marketplace_sell_price_placeholder: StringResource by lazy {
      StringResource("string:marketplace_sell_price_placeholder", "marketplace_sell_price_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7287, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5987, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5419, 50),
      ))
    }

@delegate:ResourceContentHash(-1_068_601_386)
internal val Res.string.marketplace_sell_publish: StringResource by lazy {
      StringResource("string:marketplace_sell_publish", "marketplace_sell_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7342, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6038, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5470, 52),
      ))
    }

@delegate:ResourceContentHash(-649_801_026)
internal val Res.string.marketplace_sell_success: StringResource by lazy {
      StringResource("string:marketplace_sell_success", "marketplace_sell_success", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7403, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6099, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5523, 60),
      ))
    }

@delegate:ResourceContentHash(-635_790_699)
internal val Res.string.marketplace_sell_title_label: StringResource by lazy {
      StringResource("string:marketplace_sell_title_label", "marketplace_sell_title_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7480, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6168, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5584, 44),
      ))
    }

@delegate:ResourceContentHash(408_477_481)
internal val Res.string.marketplace_sell_title_placeholder: StringResource by lazy {
      StringResource("string:marketplace_sell_title_placeholder", "marketplace_sell_title_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7533, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6213, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5629, 70),
      ))
    }

@delegate:ResourceContentHash(1_130_741_063)
internal val Res.string.marketplace_seller: StringResource by lazy {
      StringResource("string:marketplace_seller", "marketplace_seller", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7624, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6280, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5700, 50),
      ))
    }

@delegate:ResourceContentHash(-2_003_448_426)
internal val Res.string.marketplace_share_a11y: StringResource by lazy {
      StringResource("string:marketplace_share_a11y", "marketplace_share_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7740, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6392, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5792, 50),
      ))
    }

@delegate:ResourceContentHash(157_111_186)
internal val Res.string.marketplace_shops_new: StringResource by lazy {
      StringResource("string:marketplace_shops_new", "marketplace_shops_new", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7807, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6451, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5843, 33),
      ))
    }

@delegate:ResourceContentHash(682_874_813)
internal val Res.string.marketplace_shops_title: StringResource by lazy {
      StringResource("string:marketplace_shops_title", "marketplace_shops_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7849, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6493, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5877, 59),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("marketplace_add_photo", Res.string.marketplace_add_photo)
  map.put("marketplace_add_photo_failed", Res.string.marketplace_add_photo_failed)
  map.put("marketplace_all", Res.string.marketplace_all)
  map.put("marketplace_all_listings", Res.string.marketplace_all_listings)
  map.put("marketplace_back_a11y", Res.string.marketplace_back_a11y)
  map.put("marketplace_cat_all", Res.string.marketplace_cat_all)
  map.put("marketplace_cat_appliances", Res.string.marketplace_cat_appliances)
  map.put("marketplace_cat_books", Res.string.marketplace_cat_books)
  map.put("marketplace_cat_clothing", Res.string.marketplace_cat_clothing)
  map.put("marketplace_cat_electronics", Res.string.marketplace_cat_electronics)
  map.put("marketplace_cat_furniture", Res.string.marketplace_cat_furniture)
  map.put("marketplace_cat_home_kitchen", Res.string.marketplace_cat_home_kitchen)
  map.put("marketplace_cat_kids", Res.string.marketplace_cat_kids)
  map.put("marketplace_cat_other", Res.string.marketplace_cat_other)
  map.put("marketplace_cat_sports", Res.string.marketplace_cat_sports)
  map.put("marketplace_cat_vehicles", Res.string.marketplace_cat_vehicles)
  map.put("marketplace_condition", Res.string.marketplace_condition)
  map.put("marketplace_condition_like_new", Res.string.marketplace_condition_like_new)
  map.put("marketplace_condition_new", Res.string.marketplace_condition_new)
  map.put("marketplace_condition_used", Res.string.marketplace_condition_used)
  map.put("marketplace_deal_claim", Res.string.marketplace_deal_claim)
  map.put("marketplace_deal_ends_days", Res.string.marketplace_deal_ends_days)
  map.put("marketplace_deal_ends_today", Res.string.marketplace_deal_ends_today)
  map.put("marketplace_deal_image_a11y", Res.string.marketplace_deal_image_a11y)
  map.put("marketplace_deal_limited", Res.string.marketplace_deal_limited)
  map.put("marketplace_deal_open_a11y", Res.string.marketplace_deal_open_a11y)
  map.put("marketplace_delete_action", Res.string.marketplace_delete_action)
  map.put("marketplace_delete_confirm", Res.string.marketplace_delete_confirm)
  map.put("marketplace_delete_failed", Res.string.marketplace_delete_failed)
  map.put("marketplace_description", Res.string.marketplace_description)
  map.put("marketplace_edit", Res.string.marketplace_edit)
  map.put("marketplace_edit_action", Res.string.marketplace_edit_action)
  map.put("marketplace_edit_failed", Res.string.marketplace_edit_failed)
  map.put("marketplace_edit_save", Res.string.marketplace_edit_save)
  map.put("marketplace_empty_description", Res.string.marketplace_empty_description)
  map.put("marketplace_empty_title", Res.string.marketplace_empty_title)
  map.put("marketplace_error", Res.string.marketplace_error)
  map.put("marketplace_featured_section", Res.string.marketplace_featured_section)
  map.put("marketplace_free", Res.string.marketplace_free)
  map.put("marketplace_hot_deals", Res.string.marketplace_hot_deals)
  map.put("marketplace_image_a11y", Res.string.marketplace_image_a11y)
  map.put("marketplace_item_description", Res.string.marketplace_item_description)
  map.put("marketplace_location", Res.string.marketplace_location)
  map.put("marketplace_mark_sold", Res.string.marketplace_mark_sold)
  map.put("marketplace_mark_sold_cancel", Res.string.marketplace_mark_sold_cancel)
  map.put("marketplace_mark_sold_confirm", Res.string.marketplace_mark_sold_confirm)
  map.put("marketplace_mark_sold_failed", Res.string.marketplace_mark_sold_failed)
  map.put("marketplace_message_seller", Res.string.marketplace_message_seller)
  map.put("marketplace_message_seller_failed", Res.string.marketplace_message_seller_failed)
  map.put("marketplace_more_from_seller", Res.string.marketplace_more_from_seller)
  map.put("marketplace_my_listings", Res.string.marketplace_my_listings)
  map.put("marketplace_photo_upload_warning", Res.string.marketplace_photo_upload_warning)
  map.put("marketplace_photo_upload_warning_dismiss", Res.string.marketplace_photo_upload_warning_dismiss)
  map.put("marketplace_price", Res.string.marketplace_price)
  map.put("marketplace_price_50_200", Res.string.marketplace_price_50_200)
  map.put("marketplace_price_any", Res.string.marketplace_price_any)
  map.put("marketplace_price_over_200", Res.string.marketplace_price_over_200)
  map.put("marketplace_price_unavailable", Res.string.marketplace_price_unavailable)
  map.put("marketplace_price_under_50", Res.string.marketplace_price_under_50)
  map.put("marketplace_report_action", Res.string.marketplace_report_action)
  map.put("marketplace_report_done", Res.string.marketplace_report_done)
  map.put("marketplace_report_failed", Res.string.marketplace_report_failed)
  map.put("marketplace_report_reason_offensive", Res.string.marketplace_report_reason_offensive)
  map.put("marketplace_report_reason_prohibited", Res.string.marketplace_report_reason_prohibited)
  map.put("marketplace_report_reason_scam", Res.string.marketplace_report_reason_scam)
  map.put("marketplace_report_reason_spam", Res.string.marketplace_report_reason_spam)
  map.put("marketplace_report_sent", Res.string.marketplace_report_sent)
  map.put("marketplace_report_submit", Res.string.marketplace_report_submit)
  map.put("marketplace_report_title", Res.string.marketplace_report_title)
  map.put("marketplace_retry", Res.string.marketplace_retry)
  map.put("marketplace_save_a11y", Res.string.marketplace_save_a11y)
  map.put("marketplace_saved", Res.string.marketplace_saved)
  map.put("marketplace_saved_a11y", Res.string.marketplace_saved_a11y)
  map.put("marketplace_search_placeholder", Res.string.marketplace_search_placeholder)
  map.put("marketplace_sell", Res.string.marketplace_sell)
  map.put("marketplace_sell_category_label", Res.string.marketplace_sell_category_label)
  map.put("marketplace_sell_city_label", Res.string.marketplace_sell_city_label)
  map.put("marketplace_sell_city_placeholder", Res.string.marketplace_sell_city_placeholder)
  map.put("marketplace_sell_condition_label", Res.string.marketplace_sell_condition_label)
  map.put("marketplace_sell_cta", Res.string.marketplace_sell_cta)
  map.put("marketplace_sell_desc_label", Res.string.marketplace_sell_desc_label)
  map.put("marketplace_sell_desc_placeholder", Res.string.marketplace_sell_desc_placeholder)
  map.put("marketplace_sell_error", Res.string.marketplace_sell_error)
  map.put("marketplace_sell_free", Res.string.marketplace_sell_free)
  map.put("marketplace_sell_invite_cta", Res.string.marketplace_sell_invite_cta)
  map.put("marketplace_sell_invite_desc", Res.string.marketplace_sell_invite_desc)
  map.put("marketplace_sell_invite_title", Res.string.marketplace_sell_invite_title)
  map.put("marketplace_sell_photo_main", Res.string.marketplace_sell_photo_main)
  map.put("marketplace_sell_photo_remove", Res.string.marketplace_sell_photo_remove)
  map.put("marketplace_sell_photos_label", Res.string.marketplace_sell_photos_label)
  map.put("marketplace_sell_price_label", Res.string.marketplace_sell_price_label)
  map.put("marketplace_sell_price_placeholder", Res.string.marketplace_sell_price_placeholder)
  map.put("marketplace_sell_publish", Res.string.marketplace_sell_publish)
  map.put("marketplace_sell_success", Res.string.marketplace_sell_success)
  map.put("marketplace_sell_title_label", Res.string.marketplace_sell_title_label)
  map.put("marketplace_sell_title_placeholder", Res.string.marketplace_sell_title_placeholder)
  map.put("marketplace_seller", Res.string.marketplace_seller)
  map.put("marketplace_share_a11y", Res.string.marketplace_share_a11y)
  map.put("marketplace_shops_new", Res.string.marketplace_shops_new)
  map.put("marketplace_shops_title", Res.string.marketplace_shops_title)
}
